export default __webpack_public_path__ + "static/media/nato.fa69be29.png";